import { FacebookOutlined, Mail, Phone, PlaceOutlined, WhatsApp } from "@mui/icons-material"

import { MAPS_SEARCH_URL, OFFICE_ADDRESS_SHORT } from "./address"

export const PHONE_RAW = "01917432274"
export const PHONE_DISPLAY = "0191 743 2274"
export const PHONE_HREF = `tel:${PHONE_RAW}`

/** Same number as phone — E.164 without + for wa.me links */
export const WHATSAPP_E164 = "441917432274"
export const WHATSAPP_DISPLAY = PHONE_DISPLAY
export const WHATSAPP_HREF = `https://wa.me/${WHATSAPP_E164}`

export const EMAIL = "support@stargaterentals.com"
export const EMAIL_HREF = `mailto:${EMAIL}`

export const FACEBOOK_URL = "https://www.facebook.com/stargaterentals"
export const FACEBOOK_DISPLAY = "Stargate Rentals"
export const FACEBOOK_PAGE_USERNAME = "stargaterentals"
export const MESSENGER_URL = `https://m.me/${FACEBOOK_PAGE_USERNAME}`
/** Optional CRA fallback; prefer Admin → Integrations → Facebook Messenger at runtime. */
export const FACEBOOK_PAGE_ID = process.env.REACT_APP_FACEBOOK_PAGE_ID || ""

export const CONTACT_LINKS = [
    {
        href: PHONE_HREF,
        icon: Phone,
        label: "Phone",
        value: PHONE_DISPLAY,
        external: false,
    },
    {
        href: WHATSAPP_HREF,
        icon: WhatsApp,
        label: "WhatsApp",
        value: WHATSAPP_DISPLAY,
        external: true,
    },
    {
        href: EMAIL_HREF,
        icon: Mail,
        label: "Email",
        value: EMAIL,
        external: false,
    },
    {
        href: FACEBOOK_URL,
        icon: FacebookOutlined,
        label: "Facebook",
        value: FACEBOOK_DISPLAY,
        external: true,
    },
    {
        href: MAPS_SEARCH_URL,
        icon: PlaceOutlined,
        label: "Collect from our office",
        value: OFFICE_ADDRESS_SHORT,
        external: true,
    },
]
